<template>
  <div :style="$route.matched[0].name != 'Inbox' ? '' : 'width: 49.5%'">
    <!-- recur.find(e => e.task_id == task_id) ? !recur.find(e => e.task_id == task_id).enabled : true -->
    <DatePicker
      v-if="!recur.find((e) => e.task_id == task_id)"
      v-model="date"
      :locale="$i18n.locale"
      :first-day-of-week="startWeek"
      @input="onDateRangeChange"
      :attributes="attrs"
    >
      <template #default="{ togglePopover }">
        <p
          class="right_sidebar__date"
          @click="togglePopover()"
          :class="backGroundColorActive"
        >
          <span class="right_sidebar__call_to_action__img">
            <img
              width="19px"
              height="19px"
              :src="require(`@/assets/static/images/calendar_task.svg`)"
              alt="calendar"
            />
          </span>
          <input
            class="date_picker"
            :value="enumDays[text] ? enumDays[text] : text"
          />
          <span
            v-if="date"
            @click="assignDateClear"
            class="right_sidebar__assign_user_clear"
          >
            <img
              :src="require(`@/assets/static/images/assign-close.svg`)"
              alt=""
            />
          </span>
        </p>
      </template>
    </DatePicker>
    <p
      v-else
      class="right_sidebar__date disabled"
      :class="backGroundColorActive"
      @mouseover="showQuetionPopup = true"
    >
      <span class="right_sidebar__call_to_action__img">
        <img
          width="19px"
          height="19px"
          :src="require(`@/assets/static/images/calendar_task.svg`)"
          alt="calendar"
        />
      </span>
      <input
        class="date_picker"
        :value="enumDays[text] ? enumDays[text] : text"
        disabled
      />
    </p>
    <div
      class="quetion_popup"
      :class="$route.name == 'InboxTaskBody' ? 'inbox-style' : ''"
      v-if="showQuetionPopup"
    >
      <div class="quetion_popup__text">
        {{ $t("recur.note.recurring_task") }}<br />
        {{ $t("recur.note.repeats") }}:
        {{ getRecurName(recur.find((e) => e.task_id == task_id).repeat) }}<br />
        {{ $t("recur.note.ends") }}:
        {{ getRecurName(recur.find((e) => e.task_id == task_id).end_type) }}
        <template
          v-if="recur.find((e) => e.task_id == task_id).end_type == 'after'"
        >
          {{ recur.find((e) => e.task_id == task_id).occurrences }}
          {{
            recur.find((e) => e.task_id == task_id).occurrences == 1
              ? $t("recur.note.occurrence")
              : $t("recur.note.occurrences")
          }}
        </template>
        <template
          v-else-if="
            recur.find((e) => e.task_id == task_id).end_type == 'on_date'
          "
        >
          {{ momentFunc(recur.find((e) => e.task_id == task_id).end_date) }}
        </template>
        <br />
        {{ $t("recur.note.show_in_advance") }}:
        {{ recur.find((e) => e.task_id == task_id).show_advance }}
        {{
          recur.find((e) => e.task_id == task_id).show_advance == 1
            ? $t("recur.note.day")
            : $t("recur.note.days")
        }}
        <br />
        {{ $t("task.due_date") }}:
        {{ momentFunc(recur.find((e) => e.task_id == task_id).dueDate) }}<br />
        <template v-if="mode == 'dev'">
          Start:
          {{
            momentFunc(
              recur.find((e) => e.task_id == task_id).activePeriodStart
            )
          }}<br />
          Finish:
          {{
            momentFunc(
              recur.find((e) => e.task_id == task_id).activePeriodFinish
            )
          }}
        </template>
      </div>
      <div class="quetion_popup__icon" @click="showQuetionPopup = false">
        <svg
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.47266 0.296875C3.57266 0.296875 0.472656 3.50472 0.472656 7.54039C0.472656 11.5761 3.57266 14.7839 7.47266 14.7839C11.3727 14.7839 14.4727 11.5761 14.4727 7.54039C14.4727 3.50472 11.3727 0.296875 7.47266 0.296875ZM7.47266 13.7491C4.17266 13.7491 1.47266 10.9552 1.47266 7.54039C1.47266 4.12559 4.17266 1.33166 7.47266 1.33166C10.7727 1.33166 13.4727 4.12559 13.4727 7.54039C13.4727 10.9552 10.7727 13.7491 7.47266 13.7491Z"
            fill="#929292"
          />
          <path
            d="M9.81819 10.6775L7.50391 8.28268L5.18962 10.6775L4.50391 9.96791L6.81819 7.57311L4.50391 5.17832L5.18962 4.46875L7.50391 6.86354L9.81819 4.46875L10.5039 5.17832L8.18962 7.57311L10.5039 9.96791L9.81819 10.6775Z"
            fill="#929292"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from "vuex";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import { EventEmitter } from "../../main";
import moment from "moment";

export default {
  name: "SetDeadline",
  props: {
    task_id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      mode: process.env.VUE_APP_MODE,
      text: this.$t("task.set_due_date"),
      date: "",
      backGroundColorActive: "",
      startWeek: 1,
      showQuetionPopup: false,
      recur: [],
      enumDays: {
        Today: this.$t("task.assign.today"),
        Yesterday: this.$t("task.assign.yesterday"),
        Tomorrow: this.$t("task.assign.tomorrow"),
      },
      attr2: [
        {
          key: "today",
          highlight: true,
          dates: new Date(),
        },
      ],
      attrs: [
        {
          key: "today",
          highlight: true,
          dates: new Date(),
        },
      ],
    };
  },
  watch: {
    get_flag_for_tasks() {
      console.log("get_change_shortcuts_render");
      setTimeout(() => {
        let task = this.getTasks[this.$route.params.project_id].find(
          (e) => e._id == this.$route.params.task_id
        );
        let assign = {
          date: task ? task.assign.date : null,
          task_id: this.$route.params.task_id,
        };
        EventEmitter.$emit("AssignDate", assign);
      }, 500);
    },
    getRenderUserData(e) {
      this.render();
    },
    $route(e) {
      setTimeout(() => {
        this.render(e.params.task_id);
      }, 100);
    },
    "$store.state.tasks.recur": {
      async handler(v) {
        setTimeout(() => {
          this.recur = v;
        }, 1000);
      },
      deep: true,
    },
    date(value) {
      if (value) {
        this.attrs = [
          {
            key: "selected",
            highlight: { backgroundColor: "#42b983" },
            dates: new Date(value),
          },
        ];
      } else {
        // если дата очищена → вернуть today
        this.attrs = [
          {
            key: "today",
            highlight: true,
            dates: new Date(),
          },
        ];
      }
    },
  },
  methods: {
    getShowEnd(recur) {
      const end_date = moment(Number(recur.end_date));
      const showFromEndDate = end_date
        .clone()
        .subtract(recur.show_in_advance, "days");
      return (
        moment(showFromEndDate).format("YYYY-MM-DD") +
        " to " +
        moment(end_date).format("YYYY-MM-DD")
      );
    },
    check_project_id() {
      if (this.$route.params.chat_id) {
        let task_id = this.$route.params.task_id;
        let parent_position = null;
        let all_ids = Object.keys(this.getTasks);
        let tasks_group = Object.values(this.getTasks);

        for (let id in tasks_group) {
          let tasks = tasks_group[id];
          if (tasks.length) {
            for (let i in tasks) {
              if (tasks[i]._id == task_id) {
                parent_position = id;
                break;
              }
            }

            if (parent_position == id) {
              break;
            }
          }
        }

        if (parent_position) {
          this.project_id = all_ids[parent_position];
        }
      }
    },
    onDateRangeChange: function () {
      this.check_project_id();

      this.$socket.emit("IN_AssignDate", {
        date: new Date(this.date).getTime(),
        task_id: this.task_id,
        project_id: this.project_id,
      });
    },
    assignDateClear: function () {
      this.check_project_id();
      this.$socket.emit("IN_AssignDate", {
        date: "",
        task_id: this.task_id,
        project_id: this.project_id,
      });
      this.text = this.$t("task.set_due_date");
      this.backGroundColorActive = "";
      this.date = null;
    },
    render(task_id) {
      try {
        this.recur = this.get_recur;

        // let assign = this.getAssigns.find(e => e.task_id == this.$route.params.task_id)
        let task = this.getTasks[this.$route.params.project_id].find(
          (e) => e._id == this.$route.params.task_id
        );
        if (!task) {
          task = this.getCompletedTasks[this.$route.params.project_id].find(
            (e) => e._id == this.$route.params.task_id
          );
        }
        let assign = {
          date: task ? task.assign.date : null,
          task_id: this.$route.params.task_id,
        };

        if (assign) {
          if (assign.date) {
            if (!isNaN(assign.date)) {
              assign.date = new Date(+assign.date).toISOString();
            }

            this.date = assign.date;

            if (assign.date) {
              let a = this.$w_date_parse(assign.date);
              this.text = a;
              // a = a.split(" ")
              // if (a.length == 1) {
              //     this.text = a[0]
              // } else {
              //     this.text = a[2] ? a[1].replace(',', '') + ' ' + a[0] + ', ' + a[2] : a[1].replace(',', '') + ' ' + a[0]
              // }
            } else {
              this.text = this.$t("task.set_due_date");
            }

            const nowDate = new Date();
            const dateLine = new Date(assign.date);

            if (this.$w_date_parse(assign.date) == "Today") {
              this.backGroundColorActive = "endTime";
            } else {
              if (nowDate.getTime() >= dateLine.getTime()) {
                this.backGroundColorActive = "endTime";
              } else {
                this.backGroundColorActive = "hasTime";
              }
            }
          } else {
            this.text = this.$t("task.set_due_date");
            this.backGroundColorActive = "";
            this.date = null;
          }
        } else {
          this.text = this.$t("task.set_due_date");
          this.backGroundColorActive = "";
          this.date = null;
        }

        if (
          this.getUserData.date_format &&
          this.getUserData.date_format.start_of_the_week
        ) {
          if (this.getUserData.date_format.start_of_the_week == "Sunday") {
            this.startWeek = 1;
          }
          if (this.getUserData.date_format.start_of_the_week == "Monday") {
            this.startWeek = 2;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    momentFunc(date) {
      return moment(Number(date))
        .locale(this.$i18n.locale)
        .format("MMM DD, YYYY");
    },
    getNextDate(recur) {
      if (this.daysFromToday(recur.next_date) < 0) {
        let nextDue = this.getNextDue(
          moment(Number(recur.next_date)),
          recur.repeat
        );
        let date = moment(Number(nextDue)); // начальная дата
        const today = moment().startOf("day");
        // Цикл работает, пока дата меньше или равна сегодняшнему дню
        while (!date.isAfter(today, "day")) {
          date = this.getNextDue(date, recur.repeat);
        }
        return this.momentFunc(date); // возвращаем итоговую дату
      }
      return this.momentFunc(recur.next_date); // если дата уже сегодня или в будущем
    },
    daysFromToday(date) {
      // Возвращает разницу в днях между сегодня и date
      const today = moment().startOf("day");
      const input = moment(Number(date)).startOf("day");
      return input.diff(today, "days");
    },
    getNextDueDate(recur, timezone = "UTC") {
      if (!recur || !recur.start_date || !recur.repeat) {
        throw new Error("Некорректный объект recur");
      }

      let current = moment(Number(recur.start_date));
      if (!current.isValid()) {
        throw new Error("Некорректная start_date");
      }

      const now = moment();

      // Шагай до тех пор, пока дата не станет в будущем
      do {
        switch (recur.repeat) {
          case "daily":
            current = current.add(1, "days");
            break;

          case "every_weekday":
            do {
              current = current.add(1, "days");
            } while ([0, 6].includes(current.day())); // выходные
            break;

          case "weekly":
            current = current.add(1, "weeks");
            break;

          case "every_2_weeks":
            current = current.add(2, "weeks");
            break;

          case "monthly":
            current = current.add(1, "months");
            break;

          case "every_2_months":
            current = current.add(2, "months");
            break;

          case "yearly":
            current = current.add(1, "years");
            break;

          default:
            throw new Error("Неподдерживаемый тип repeat");
        }
      } while (current.isSameOrBefore(now, "day"));

      // Проверка окончания по after
      if (recur.ends === "after" && recur.ends_after != null) {
        if ((recur.occurrences_count || 0) + 1 >= recur.ends_after) {
          return { next: null, message: "end" };
        }
      }

      // Проверка окончания по on_date
      if (recur.ends === "on_date" && recur.ends_on) {
        const limit = moment(Number(recur.ends_on));
        if (current.isAfter(limit, "day")) {
          return { next: null, message: "end" };
        }
      }

      return { next: current.toISOString() };
    },
    getNextDue(current, repeat) {
      switch (repeat) {
        case "daily":
          return current.clone().add(1, "days");

        case "every_weekday": {
          const next = current.clone().add(1, "days");
          const day = next.day(); // 0 = Sunday, 6 = Saturday

          if (day === 6) return next.add(2, "days"); // skip Saturday → Monday
          if (day === 0) return next.add(1, "days"); // skip Sunday → Monday
          return next;
        }

        case "weekly":
          return current.clone().add(1, "weeks");

        case "every_two_weeks":
          return current.clone().add(2, "weeks");

        case "monthly":
          return current.clone().add(1, "months");

        case "every_two_months":
          return current.clone().add(2, "months");

        case "yearly":
          return current.clone().add(1, "years");

        default:
          return current.clone(); // fallback
      }
    },
    getRecurName(sub) {
      switch (sub) {
        case "daily":
          return this.$t("recur.repeat.daily");
        case "every_weekday":
          return this.$t("recur.repeat.every_weekday");
        case "weekly":
          return this.$t("recur.repeat.weekly");
        case "every_two_weeks":
          return this.$t("recur.repeat.every_two_weeks");
        case "monthly":
          return this.$t("recur.repeat.monthly");
        case "every_two_months":
          return this.$t("recur.repeat.every_two_months");
        case "yearly":
          return this.$t("recur.repeat.yearly");
        case "never":
          return this.$t("recur.ends.never");
        case "after":
          return this.$t("recur.ends.after");
        case "on_date":
          return ""; //this.$t('recur.ends.on_date');
        default:
          return sub;
      }
    },
  },
  mounted() {
    this.project_id = this.$route.params.project_id;

    // if (this.$route.params.project_id) {
    //     this.project_id = this.$route.params.project_id
    //     // localStorage.setItem('project_id', this.$route.params.project_id)
    // } else {
    //     let projectID = localStorage.getItem('project_id')
    //     this.project_id = projectID ? projectID : this.$route.params.project_id
    // }

    // EventEmitter.$on('AssignFind', (data) => {
    //     this.render()
    // })

    // EventEmitter.$on('AssignFind', (data) => {
    //     if(data.assign.date){
    //         // console.log(data.assign.date)
    //         if (!isNaN(data.assign.date)) {
    //             data.assign.date = new Date(+data.assign.date).toISOString()
    //         }
    //         this.date = data.assign.date
    //         // this.text = data.assign ? this.$w_date_parse(data.assign.date) : "Set due date";
    //         if (data.assign) {
    //             let a = this.$w_date_parse(data.assign.date)
    //             a = a.split(" ")
    //             if (a.length == 1) {
    //                 this.text = a[0]
    //             } else {
    //                 this.text = a[2] ? a[1].replace(',', '') + ' ' + a[0] + ', ' + a[2] : a[1].replace(',', '') + ' ' + a[0]
    //             }
    //         } else {
    //             this.text = "Set due date"
    //         }
    //         const nowDate = new Date()
    //         const dateLine = new Date(data.assign.date)
    //         if(this.$w_date_parse(data.assign.date) == 'Today'){
    //             this.backGroundColorActive = 'endTime'
    //         }else{
    //             if (nowDate.getTime() >= dateLine.getTime()) {
    //                 this.backGroundColorActive = 'endTime'
    //             } else {
    //                 this.backGroundColorActive = 'hasTime'
    //             }
    //         }
    //     }else{
    //         this.text = "Set due date";
    //         this.backGroundColorActive = ''
    //         this.date = ''
    //     }
    // })

    this.render();

    EventEmitter.$on("AssignDate", (data) => {
      if (data.date) {
        if (data.task_id == this.$route.params.task_id) {
          if (!isNaN(data.date)) {
            data.date = new Date(+data.date).toISOString();
          }

          this.date = data.date;
          // this.text = data ? this.$w_date_parse(data.date) : "Set due date";
          if (data.date) {
            let a = this.$w_date_parse(data.date);
            this.text = a;
            // a = a.split(" ")
            // if (a.length == 1) {
            //     this.text = a[0]
            // } else {
            //     this.text = a[2] ? a[1].replace(',', '') + ' ' + a[0] + ', ' + a[2] : a[1].replace(',', '') + ' ' + a[0]
            // }
          } else {
            this.text = this.$t("task.set_due_date");
          }
          const nowDate = new Date();
          const dateLine = new Date(data.date);
          // console.log(dateLine, data.date)
          if (this.$w_date_parse(data.date) == "Today") {
            this.backGroundColorActive = "endTime";
          } else {
            if (nowDate.getTime() > dateLine.getTime()) {
              this.backGroundColorActive = "endTime";
            } else {
              this.backGroundColorActive = "hasTime";
            }
          }
        }
      } else {
        this.text = this.$t("task.set_due_date");
        this.backGroundColorActive = "";
        this.date = null;
      }
    });
  },
  computed: {
    ...mapGetters([
      "getTasks",
      "getUserData",
      "getRenderUserData",
      "getAssigns",
      "get_recur",
      "get_flag_for_tasks",
      "getCompletedTasks",
    ]),
  },
  components: {
    DatePicker,
  },
};
</script>
